import { ACCOUNT } from "./accountConstants.js";
import { INITIAL, singleEntityReducer } from "../entity/singleEntityReducer.js";

export const INITIAL_ACCOUNT = {
  ...INITIAL,
  data: {
    ...INITIAL.data,
    timezone: null
  },
  permissions: {}
};

export const accountReducer = (state = INITIAL_ACCOUNT, action = {}) => {
  switch (action.type) {
    case ACCOUNT.SET_TIMEZONE:
      return {
        ...state,
        data: {
          ...state.data,
          timezone: action.payload.timezone
        }
      };

    case ACCOUNT.RECEIVE:
      let data = action.payload;

      const timeReceived = Date.now();

      let permissions = {};
      if (data.permissions && data.permissions.length > 0) {
        permissions = data.permissions.reduce((acc, item) => {
          acc[item] = true;
          return acc;
        }, {});
      }

      return {
        ...state,
        isFetching: false,
        isStale: false,
        timeReceived,
        lastCreated: null,
        data,
        permissions
      };

    default:
      return singleEntityReducer(ACCOUNT)(state, action);
  }
};
